import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ArrowLeft, Play } from 'lucide-react'
import PageHero from '../shared/PageHero'
import { contentApi, YouTubeVideo } from '../../services/contentApi'

const BlogDetailPage = () => {
  const { slug } = useParams<{ slug: string }>()
  const [blog, setBlog] = useState<Awaited<ReturnType<typeof contentApi.getBlog>> | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!slug) return
    contentApi.getBlog(slug)
      .then((data) => {
        setBlog(data)
        document.title = `${data.title} | Aonla Stay`
      })
      .catch(() => setBlog(null))
      .finally(() => setLoading(false))
  }, [slug])

  if (loading) return <div className="min-h-[50vh] flex items-center justify-center"><div className="animate-spin h-8 w-8 border-4 border-primary-500 border-t-transparent rounded-full" /></div>
  if (!blog) return <div className="max-w-3xl mx-auto px-4 py-20 text-center"><h1 className="text-2xl font-bold">Article not found</h1><Link to="/blogs" className="mt-4 inline-block text-primary-600">← All blogs</Link></div>

  const relatedVideos = (blog.youtube_videos || []) as YouTubeVideo[]

  return (
    <div className="min-h-screen bg-white">
      <PageHero title={blog.title} subtitle={blog.summary} />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <Link to="/blogs" className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-primary-600 mb-8"><ArrowLeft className="h-4 w-4" /> All blogs</Link>
        <div className="prose prose-lg max-w-none prose-headings:text-gray-900 prose-a:text-primary-600" dangerouslySetInnerHTML={{ __html: blog.content || `<p>${blog.summary || ''}</p>` }} />

        {relatedVideos.length > 0 && (
          <div className="mt-14 pt-10 border-t border-gray-200">
            <h2 className="text-xl font-bold text-gray-900 mb-6">Related Manauna Dham videos</h2>
            <div className="grid sm:grid-cols-2 gap-4">
              {relatedVideos.map((v) => (
                <a key={v.video_id} href={v.url} target="_blank" rel="noopener noreferrer" className="flex gap-3 rounded-xl border border-gray-200 p-3 hover:border-red-200 hover:shadow-sm transition-all">
                  <div className="relative shrink-0 w-36 aspect-video rounded-lg overflow-hidden bg-gray-900">
                    <img src={`https://i.ytimg.com/vi/${v.video_id}/mqdefault.jpg`} alt="" className="w-full h-full object-cover" />
                    <Play className="absolute inset-0 m-auto h-8 w-8 text-white drop-shadow" fill="white" />
                  </div>
                  <p className="text-sm font-medium text-gray-900 line-clamp-3">{v.title}</p>
                </a>
              ))}
            </div>
          </div>
        )}
      </article>
    </div>
  )
}

export default BlogDetailPage
